import React from 'react'
import Mscard from './Mscard'
import Dtpcard from './Dtpcard'
import AnimatedButton from './button'
import Clang from './Clang'
import Editing from './Editing'
import Tally from './Tally'
import Html from './Html'
import {msofficeImg} from '../data.js'
import {dtpImg} from '../data.js'
import {cImg} from '../data.js'
import {editingImg} from '../data.js'
import {tallyimg} from '../data.js'
import {htmlimg} from '../data.js'
import { useNavigate } from 'react-router-dom'

function Cards() {

  const msofficeImage = msofficeImg;
  const dtpImage = dtpImg;
  const cImage = cImg;
  const editingImage = editingImg;
  const tallyImage = tallyimg;
  const htmlImage = htmlimg;

  const navigate = useNavigate();
  return (
    <div>
      <div id='msoffice' className='container-course1'>
        <Mscard msofficeImage={msofficeImage}/>
    <div className="container">
      <div className="textCard1">
        <div><h3 id="h3">MS Office</h3><br/><p>🖥️ A comprehensive course covering Word, Excel, PowerPoint & more. Perfect for beginners and professionals. <br/>📅 Duration: 2 months.</p></div>
      </div>
      <div className='button btn-alignment'>
        <AnimatedButton onClick={() => navigate("/coursedetails/ms-Office")}/>
      </div>
    </div>
      </div>
      
      <div id='dtp' className='container-course2'>
        <Dtpcard dtpImage={dtpImage}/>
        <div className="container">
      <div className="textCard2">
        <div><h3 id="h3">DTP</h3><br/><p> Learn DTP – Master Design & Publishing! Our DTP course covers everything from layout design to professional printing tools.<br/>
          🖥️ Learn software like CorelDRAW, Photoshop, and InDesign.<br/>📅 Duration: 2 months.</p></div>
      </div>
      <div className='button btn-dtpalignment'>
        <AnimatedButton onClick={() => navigate("/coursedetails/dtp")}/>
      </div>
    </div>
      </div>


        <div id='msoffice' className='container-course1'>
        <Clang cImage={cImage}/>
        <div className="container">
      <div className="textCard1">
        <div><h3 id="h3">C Language</h3><br/><p>🖥️ Master the fundamentals of programming with C.<br/>🧠 Learn logic building, syntax, and real-time coding techniques. <br/>📅 Duration: 2 months.</p>
        </div>
      </div>
      <div className='button btn-alignment'>
        <AnimatedButton onClick={() => navigate("/coursedetails/c-language")}/>
      </div>
    </div>
      </div>

      <div id='dtp' className='container-course2'>
        <Editing editingImage={editingImage}/>
        <div className="container">
      <div className="textCard2">
        <div><h3 id="h3">Video Editing</h3><br/><p>🖥️ Unleash your creativity with professional video editing.<br/>🎬 Learn tools like Adobe Premiere Pro and basic motion graphics.<br/>📅 Duration: 2 months.</p>
      </div>
      </div>
      <div className='button btn-dtpalignment'>
        <AnimatedButton onClick={() => navigate("/coursedetails/video-editing")}/>
      </div>
    </div>
      </div>


        <div id='msoffice' className='container-course1'>
        <Tally tallyImage={tallyImage}/>
        <div className="container">
      <div className="textCard1">
        <div><h3 id="h3">Tally</h3><br/><p>🖥️ Get skilled in accounting with Tally ERP 9.<br/>📊 Learn inventory, GST, payroll, and financial reporting.<br/>📅 Duration: 2 months.</p>
      </div>
      </div>
      <div className='button btn-alignment btn-tally'>
        <AnimatedButton onClick={() => navigate("/coursedetails/tally")}/>
      </div>
    </div>
      </div>

        <div id='dtp' className='container-course2'>
        <Html htmlImage={htmlImage}/>
        <div className="container">
      <div className="textCard2">
        <div><h3 id="h3">HTML</h3><br/><p>🖥️ Build the foundation of web development with HTML.<br/>🌐 Learn to structure web pages using HTML5 standards..<br/>📅 Duration: 2 months.</p>
      </div>
      </div>
      <div className='button btn-dtpalignment btn-html'>
        <AnimatedButton onClick={() => navigate("/coursedetails/html")}/>
      </div>
    </div>
      </div>
    </div>
  )
}

export default Cards